import { URLS } from 'api/constants';
import { IVariables } from 'constants/types';
import { apiGet } from './client';

const emptyVariable = (name = ''): IVariables =>
  ({
    value: '',
    name,
  }) as IVariables;

export async function getVariableByName(name?: string) {
  try {
    return await apiGet<IVariables>(`${URLS.VARIABLES_BY_NAME}${name ?? ''}`);
  } catch {
    return emptyVariable(name);
  }
}

export async function getVariableById(id?: string) {
  try {
    return await apiGet<IVariables>(`${URLS.VARIABLES_BY_ID}${id ?? ''}`);
  } catch {
    return emptyVariable(id);
  }
}

export async function listVariables() {
  return apiGet<IVariables>(URLS.VARIABLES);
}
